import { render, staticRenderFns } from "./dataloader.vue?vue&type=template&id=bb403a1a"
import script from "./dataloader.vue?vue&type=script&lang=js"
export * from "./dataloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports